export const ALL_USERS_FILTER = {
  name: 'All users',
  id: 'All users'
}
export const NO_USERS_FILTER = {
  name: 'No wave',
  id: 'No wave'
}

export const ALL_STORY_TYPES_FILTER = {
  name: 'All Story Types',
  id: 'All Story Types'
}

export const AUDIO_STORY_TYPE_FILTER = {
  name: 'Audio',
  id: 'audio'
}

export const VIDEO_STORY_TYPE_FILTER = {
  name: 'Video',
  id: 'video'
}

export const TEXT_STORY_TYPE_FILTER = {
  name: 'Text',
  id: 'text'
}

export const ALL_TIME_PERIOD_FILTER = {
  name: 'All time',
  id: 'All time'
}

export const MONTHLY_PERIOD_FILTER = {
  name: 'Monthly',
  id: 'Monthly'
}

export const STORY_TYPE_FILTERS = [ALL_STORY_TYPES_FILTER, AUDIO_STORY_TYPE_FILTER, TEXT_STORY_TYPE_FILTER, VIDEO_STORY_TYPE_FILTER]
export const PERIOD_TYPE_FILTERS = [ALL_TIME_PERIOD_FILTER, MONTHLY_PERIOD_FILTER]
